
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-index-ui',
  currentProjectVersion: 'static-2.46863',
  depVersions: {
  "crm-index-ui": "static-2.46863",
  "ably-hubspot-js": "static-1.435",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3293",
  "calling-orchestration-shared-library": "static-1.29813",
  "card-associated-objects-lib": "static-1.38404",
  "card-associated-objects-lib-legacy": "static-1.6057",
  "client-types": "static-1.372",
  "commerce-contract-lib": "static-1.5851",
  "commerce-products-lib": "static-1.4591",
  "commerce-shared-components-lib": "static-1.14475",
  "commerce-tools-ui-lib": "static-1.6297",
  "commerce-tours-lib": "static-1.3322",
  "contextual-settings-lib": "static-1.1780",
  "credit-memos-ui-lib": "static-1.5858",
  "crm_data": "static-4.86423",
  "crm-cards-global-registry": "static-1.14504",
  "crm-common-dlb": "static-1.4037",
  "crm-component-utils": "static-1.34250",
  "crm-configuration-iframe-lib": "static-1.297",
  "crm-configuration-onboarding-lib": "static-1.5275",
  "crm-index-associations-lib": "static-1.5103",
  "crm-index-visualization-core": "static-1.2627",
  "crm-legacy-global-containers": "static-1.22501",
  "crm-legacy-links": "static-1.71309",
  "crm-message-bus": "static-1.36382",
  "crm-object-board-core": "static-1.12439",
  "crm-object-gantt": "static-1.2480",
  "crm-object-map": "static-1.1768",
  "crm-object-search-query-utilities": "static-1.6131",
  "crm-object-search-query-utilities-test-utils": "static-1.5792",
  "crm-pipeline-board-settings-lib": "static-1.25502",
  "crm-pipelines-api-client-types": "static-1.3055",
  "customer-data-bulk-actions": "static-1.29745",
  "customer-data-objects": "static-1.6330",
  "customer-data-objects-ui-components": "static-1.11603",
  "customer-data-properties": "static-1.45420",
  "customer-data-sidebar": "static-2.40653",
  "customer-data-views-management": "static-1.22009",
  "data-fetching-client": "static-1.8338",
  "data-privacy-hub-settings-service-types": "static-1.2904",
  "demographics-client": "static-1.4129",
  "dispatcher": "static-1.111",
  "embedded-academy-lib": "static-1.9955",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.300",
  "external-options-client-types": "static-1.3008",
  "feedback-loader": "static-1.26420",
  "foundations-components": "static-1.5909",
  "foundations-components-test-utils": "static-1.3394",
  "foundations-theming": "static-1.3030",
  "foundations-theming-specialty": "static-1.747",
  "framework-data-schema-quick-fetch": "static-1.5488",
  "framework-data-schema-resolvers": "static-1.5583",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7051",
  "framework-data-table": "static-2.8470",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "growth-onboarding-beacon": "static-1.2447",
  "growth-payments-core": "static-1.20846",
  "head-dlb": "static-1.3911",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-promise-utils": "static-1.4245",
  "hs-test-utils": "static-1.6710",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3546",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10213",
  "I18n": "static-7.1383",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "inbound-db-meta-service-client": "static-1.2708",
  "inbound-db-properties-service-client": "static-1.2851",
  "inbounddb-objects-service-types": "static-1.3137",
  "jasmine-immutable": "static-1.1682",
  "jasmine-runner": "static-1.5125",
  "laboratory-lib": "static-3.5970",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4962",
  "marketplace-embed": "static-1.16135",
  "marketplace-ui-client-types": "static-1.11228",
  "object-builder-ui-client": "static-1.41701",
  "onboarding-data-sync-lib": "static-1.95",
  "onboarding-scopes": "static-1.5271",
  "onboarding-tours": "static-1.14113",
  "payments-zero-states-lib": "static-1.14351",
  "pipeline-validation-client-types": "static-1.2796",
  "PortalIdParser": "static-2.278",
  "products-iframe-lib": "static-1.2714",
  "products-ui-components": "static-1.35111",
  "property-management-iframe": "static-1.7997",
  "quartz": "static-1.5474",
  "quick-fetch": "static-1.2908",
  "raven": "static-3.4646",
  "react": "static-7.151",
  "react-dlb": "static-1.52",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-4.5",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15302",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4249",
  "recording-review-components-lib": "static-1.26261",
  "reference-resolvers-lite": "static-1.6692",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7111",
  "reporting-data": "static-1.61351",
  "reporting-dlb": "static-1.54269",
  "reporting-testing-lib": "static-1.3286",
  "reporting-visualizations": "static-1.53428",
  "sales-views-client-types": "static-1.3049",
  "self-service-api": "static-1.8918",
  "settings-ui-lib": "static-1.11273",
  "signup-constants": "static-1.16043",
  "styled-components": "static-2.64",
  "superstore": "static-1.3488",
  "svh-onboarding-config-shared-lib": "static-1.2242",
  "tinymce": "static-6.5",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10774",
  "ui-addon-draggable": "static-2.1198",
  "ui-addon-integrations-directory-panel": "static-2.6707",
  "ui-addon-upgrades": "static-9.15921",
  "ui-components-test-utils": "static-1.4352",
  "UIComponents": "static-3.7161",
  "usage-based-billing-components-lib": "static-1.3402",
  "usage-tracker-core": "static-1.6031",
  "user-context": "static-1.3887",
  "webpack-env": "static-1.54",
  "wootric-nps": "static-1.5662",
  "account-and-billing-components": "static-1.16315",
  "account-and-billing-fintech-outages": "static-3.15065",
  "accounting-extension-card-ui": "static-1.31155",
  "accounting-integrations-ui-components": "static-1.4754",
  "ai-components-ui-library": "static-1.5091",
  "apollo-link-hub-http": "static-2.3503",
  "attribution-sidebar-cards": "static-1.38628",
  "BizOpsCrmUIComponents": "static-1.40337",
  "call-widget-addon": "static-2.27400",
  "calling-integration-sdk-support": "static-1.25454",
  "calling-integration-timeline-event": "static-1.13154",
  "calling-internal-common": "static-1.29941",
  "calling-lifecycle-internal": "static-1.58674",
  "calling-ui-library": "static-1.64593",
  "card-biz-ops-customer-success-lib": "static-1.71467",
  "card-biz-ops-domain-controls-lib": "static-1.71468",
  "card-biz-ops-related-contacts-lib": "static-1.71467",
  "card-crm-attribution-lib": "static-1.49769",
  "card-deal-collaborators-lib": "static-1.32522",
  "card-deal-shared-view-lib": "static-1.63504",
  "card-engagement-attachments-lib": "static-1.67714",
  "card-gdpr-subscriptions-card-lib": "static-1.41762",
  "card-integration-card-lib": "static-1.67703",
  "card-linked-in-sales-navigator-lib": "static-1.35495",
  "card-lists-lib": "static-1.65825",
  "card-past-conversations-lib": "static-1.32023",
  "card-payment-history-lib": "static-1.31367",
  "card-playbooks-lib": "static-1.57992",
  "card-preview-highlight-lib": "static-1.70051",
  "card-profile-products-lib": "static-1.51541",
  "card-profile-quotes-lib": "static-1.78696",
  "card-properties-lib": "static-1.38490",
  "card-sales-activities-timeline": "static-1.32797",
  "card-target-account-lib": "static-1.67452",
  "card-website-activity-lib": "static-1.68251",
  "chatspot-widget-iframe": "static-1.15165",
  "collaboration-sidebar": "static-1.52032",
  "commerce-billing-lib": "static-1.14452",
  "commerce-subscription-cards-lib": "static-1.25767",
  "commerce-subscription-lib": "static-1.30942",
  "composer-plugins": "static-1.66498",
  "conversations-thread-view-crm-events": "static-1.29177",
  "copilot-toolkit": "static-1.5967",
  "credit-memos-iframe-lib": "static-1.5860",
  "crm_components": "static-3.86423",
  "crm_schema": "static-3.86460",
  "crm_ui": "static-5.86381",
  "crm_universal": "static-1.20465",
  "crm-activity-creator-interaction-window": "static-1.40383",
  "crm-activity-creator-interactions-legacy": "static-1.30852",
  "crm-activity-creator-widgets": "static-1.46434",
  "crm-associations-table": "static-1.36099",
  "crm-cards": "static-1.39046",
  "crm-cards-sdk": "static-1.37749",
  "crm-command-handler": "static-1.30450",
  "crm-display-components": "static-1.20000",
  "crm-events-components": "static-1.55207",
  "crm-events-data": "static-1.55220",
  "crm-fe-perf": "static-1.21719",
  "crm-index-ui-toolbar": "static-1.1938",
  "crm-index-view-table-edit-columns-modal": "static-1.15669",
  "crm-index-visualization-toolbar": "static-1.2363",
  "crm-index-visualization-toolbar-test-utils": "static-1.1734",
  "crm-links": "static-1.4820",
  "crm-object-board": "static-1.22360",
  "crm-object-board-card": "static-1.12435",
  "crm-object-preview": "static-1.21057",
  "crm-object-table": "static-1.17217",
  "crm-timeline": "static-1.83546",
  "crm-timeline-tasks": "static-1.32359",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.472",
  "customer-data-board": "static-1.19450",
  "customer-data-board-card": "static-1.19411",
  "customer-data-bulk-actions-container": "static-1.15456",
  "customer-data-communicator": "static-1.39868",
  "customer-data-email": "static-1.15671",
  "customer-data-filters-ui": "static-1.33478",
  "customer-data-property-utils": "static-1.6646",
  "customer-data-reference-ui-components": "static-1.11700",
  "customer-data-rte": "static-1.28748",
  "customer-data-ui-utilities": "static-1.8445",
  "deal-registration-ui": "static-1.29832",
  "deal-splits-cards-ui": "static-1.39316",
  "deal-splits-sidebar": "static-1.39222",
  "draft-email-branding-plugin": "static-2.20019",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.19156",
  "draft-signature-plugin": "static-1.19782",
  "email-confirm-ui": "static-2.4344",
  "EmailSignatureEditor": "static-1.20358",
  "ExportDialog": "static-6.9110",
  "ExtensionInstallHelpers": "static-1.529",
  "file-manager-components": "static-1.18153",
  "FileManagerLib": "static-1.33794",
  "flywheel-feedback-panel-components": "static-1.5998",
  "foundations-assets": "static-1.3635",
  "framework-app-settings-features-lib": "static-1.3764",
  "frontend-preferences-client": "static-1.6591",
  "getting-started-shared-tasks": "static-1.12008",
  "graphql": "static-1.58",
  "growth-data-modal": "static-1.3930",
  "growth-feature-usage-components": "static-1.4372",
  "growth-feature-usage-data": "static-1.4591",
  "growth-onboarding-empty-states": "static-1.3902",
  "HeadJS": "static-2.570",
  "hubspot-prosemirror": "static-1.13349",
  "hubspot-url-utils": "static-1.3063",
  "HubStyle": "static-2.10522",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16795",
  "InboxConnectUtils": "static-4.9371",
  "integration-settings-components": "static-1.10339",
  "integrations-directory-panel-lib": "static-1.7725",
  "invoices-card-lib": "static-1.51361",
  "invoices-iframe-lib": "static-1.51290",
  "invoices-ui-lib": "static-1.49232",
  "lead-tracking-lib": "static-1.33651",
  "marketing-contacts-lib": "static-1.7861",
  "marketing-contacts-ui": "static-1.6353",
  "marketing-event-cards-ui": "static-1.31602",
  "marketplace-ui-apps-core": "static-1.12358",
  "marketplace-ui-common": "static-1.13822",
  "metrics-js": "static-1.8459",
  "mobile-manifest-mixins": "static-1.341",
  "native-integrations-shared-strings": "static-1.6551",
  "nav-meta": "static-1.25318",
  "object-comments-thread-lib": "static-1.5881",
  "onboarding-data-sync-lib-shared-msw-handlers": "static-1.15",
  "onboarding-tours-client": "static-1.3216",
  "orders-card-lib": "static-1.16659",
  "panel-deal-registration-ai-summary-lib": "static-1.22440",
  "partner-shared-view-ui": "static-1.42139",
  "playbooks-modal": "static-1.75165",
  "playlists-lib": "static-1.6634",
  "products-highlight-card-lib": "static-1.12876",
  "property-translator": "static-1.4112",
  "quartz-core": "static-1.4693",
  "quotes-ui-lib": "static-1.73889",
  "react-beautiful-dnd": "static-1.13",
  "react-colorpicker": "static-2.8958",
  "react-immutable-render-mixin": "static-1.9",
  "react-select-plus": "static-1.65",
  "recent-activities-card": "static-1.53071",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reference-resolvers": "static-1.6869",
  "reporting-action-components": "static-1.35921",
  "reporting-crm-object-table": "static-1.2519",
  "reporting-enablement": "static-1.16727",
  "reporting-ui-components": "static-2.58629",
  "reselect": "static-2.16",
  "rich-text-lib": "static-1.17313",
  "rpc-client-utils": "static-1.3434",
  "SalesContentIndexUI": "static-3.6996",
  "salesforce-sync-card-ui": "static-1.7670",
  "sanitize-text": "static-1.6896",
  "sequences-lib": "static-1.5807",
  "SharedI18nStrings": "static-1.162",
  "subscriptions-components": "static-1.41060",
  "svh-conversations-settings-lib": "static-1.2242",
  "tasks-lib": "static-1.32433",
  "timezone-utils": "static-2.3965",
  "transcript-sidebar": "static-1.62322",
  "trellis-ecosystem": "static-1.4460",
  "ui-addon-avatars": "static-2.8148",
  "ui-addon-form-validation": "static-1.9737",
  "ui-addon-i18n": "static-1.9642",
  "ui-addon-iframeable": "static-1.7606",
  "ui-addon-opt": "static-4.7366",
  "ui-addon-react-router-dom": "static-1.8327",
  "ui-addon-scriptloader": "static-1.11107",
  "ui-addon-teams": "static-1.19660",
  "ui-asset-management-lib": "static-1.8954",
  "ui-business-units-lib": "static-1.7591",
  "ui-gdpr-components": "static-1.8966",
  "ui-shepherd-react": "static-3.8771",
  "ui-universal-auth": "static-1.7510",
  "usage-tracker": "static-1.6181",
  "usage-tracker-container": "static-1.6171",
  "atom": "static-1.3938",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "sanitize": "static-1.3102",
  "hs-promise-rejection-tracking": "static-1.4190",
  "raven-hubspot": "static-1.4953",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.2374",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1751",
  "quartz-webpack": "static-1.1698",
  "ably": "static-1.18",
  "calling-orchestration-schema": "static-1.30038",
  "avatar-components": "static-1.1137",
  "calling-global-api": "static-1.57292",
  "campaigns-lib": "static-1.21922",
  "card-payment-highlight-lib": "static-1.31503",
  "customer-data-tracking": "static-1.5516",
  "payment-link-components": "static-1.18264",
  "payments-embed-points-lib": "static-1.9198",
  "persist-promise": "static-1.2463",
  "PatternValidationJS": "static-1.437",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1285",
  "zustand": "static-1.51",
  "products-ui-components-shared-msw-handlers": "static-1.7350",
  "hs-story-utils": "static-1.8112",
  "msw": "static-1.39",
  "payments-enrollment-embed-lib": "static-1.17356",
  "StyleGuideUI": "static-3.456",
  "ui-images": "static-2.812",
  "cv-backend-services": "static-1.1120",
  "growth-onboarding-confetti": "static-1.1826",
  "payments-post-enroll-local-storage-lib": "static-1.3813",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "react-dnd-compat": "static-1.3374",
  "magpie-lib": "static-1.4389",
  "magpie-types": "static-1.3849",
  "adobe-sign-cards-lib": "static-1.13002",
  "ai-addon-copilot-preview": "static-1.4303",
  "ai-catchup-cards-lib": "static-1.2389",
  "automation-ui-crm-card-workflows-invoker": "static-1.4968",
  "buyer-intent-card": "static-1.16082",
  "card-call-summaries-lib": "static-1.30047",
  "card-company-summary-lib": "static-1.13716",
  "card-customer-spend-trends-lib": "static-1.21073",
  "card-flywheel-activity-history-lib": "static-1.2145",
  "card-flywheel-company-overview-lib": "static-1.11174",
  "card-flywheel-domain-review-history-lib": "static-1.802",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.11174",
  "card-guest-access-management-lib": "static-1.2780",
  "card-guided-execution-activities": "static-1.4212",
  "card-knowledge-base-lib": "static-1.6754",
  "card-lead-insights": "static-1.9485",
  "card-lead-qualification-lib": "static-1.24930",
  "card-object-highlight-lib": "static-1.1512",
  "card-object-summary-lib": "static-1.2866",
  "card-other-tickets-lib": "static-1.15029",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25945",
  "card-partner-client-unified-usage-score-lib": "static-1.20310",
  "card-prospecting-research-agent": "static-1.2373",
  "card-target-account-signals": "static-1.922",
  "card-tasks-timeline-lib": "static-1.9619",
  "card-ticket-summary-lib": "static-1.11466",
  "commerce-billing-engine-lib": "static-1.1316",
  "crm-actions": "static-1.4779",
  "crm-associations-pivot": "static-1.34229",
  "crm-attribution-report": "static-1.553",
  "crm-clv-report": "static-1.2887",
  "crm-data-highlights": "static-1.36637",
  "crm-events-viz-cards": "static-1.35853",
  "crm-events-viz-totals": "static-1.27406",
  "crm-extension": "static-1.35957",
  "crm-csat": "static-1.159",
  "crm-pipeline-approvals-lib": "static-1.18903",
  "crm-properties-list": "static-1.33275",
  "crm-property-history": "static-1.11335",
  "crm-quick-actions": "static-1.12785",
  "crm-relative-timeline": "static-1.13213",
  "crm-report": "static-1.36844",
  "crm-simple-deadline": "static-1.13431",
  "crm-stage-tracker": "static-1.31808",
  "crm-statistics": "static-1.25853",
  "custom-events-card-lib": "static-1.414",
  "customer-overview-card-lib": "static-1.4524",
  "customer-success-contacts-card-lib": "static-1.12800",
  "deal-summary-components": "static-1.15638",
  "docusign-cards-lib": "static-1.22405",
  "flywheel-growth-plans-crm-card": "static-1.1755",
  "guided-actions-card": "static-1.9204",
  "guided-selling-stage-tracker-card": "static-1.6416",
  "health-score-card-lib": "static-1.16083",
  "intelligence-overview-card": "static-1.9914",
  "intelligence-overview-lib": "static-1.8087",
  "invoices-history-card-lib": "static-1.25645",
  "lead-scores-card": "static-1.12357",
  "legacy-sidebar-card-lib": "static-1.29597",
  "payment-schedule-card-lib": "static-1.23163",
  "playbooks-card": "static-1.37875",
  "predictive-scores-card": "static-1.25519",
  "process-guide-cards": "static-1.3556",
  "products-cards-lib": "static-1.4184",
  "purchase-history-lib": "static-1.15345",
  "ui-google-drive-attachments": "static-1.1640",
  "ui-google-drive-insights": "static-1.1642",
  "customer-data-properties-shared-msw-handlers": "static-1.6295",
  "ai-settings-ui-library": "static-1.5798",
  "crm-configuration-common-lib": "static-1.6835",
  "crm-import-wizard-lib": "static-1.36944",
  "react-flip-move": "static-1.46",
  "ui-addon-draggable-compat": "static-2.2982",
  "user-context-client": "static-1.3468",
  "ts-schema": "static-1.3059",
  "framework-builder-read-service-client": "static-1.2980",
  "hub-http-shared-msw-handlers": "static-1.6965",
  "multi-currency-client-types": "static-1.2729",
  "customer-data-associations": "static-1.5921",
  "react-virtualized-auto-sizer": "static-1.24",
  "react-window": "static-1.13",
  "task-forms-lib": "static-1.35729",
  "universal-associations-select": "static-1.9510",
  "crm-index-visualization-object-layout": "static-1.151",
  "fast-json-stable-stringify": "static-1.4",
  "csstype": "static-1.38",
  "jasmine": "static-4.3059",
  "usage-tracker-public": "static-1.5992",
  "content-assistance-lib": "static-1.6204",
  "crm-record-access-management-lib": "static-1.21038",
  "customer-data-content": "static-1.24371",
  "draft-content-plugins": "static-1.24097",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "enrichment-properties-lib": "static-1.9427",
  "FireAlarmUi": "static-1.3561",
  "flux-actions": "static-1.268",
  "marketing-contacts-client": "static-1.6354",
  "pipeline-governance-client-types": "static-1.3112",
  "prospecting-agent-lib": "static-1.6747",
  "react-virtualized": "static-2.73",
  "subscriptions-client": "static-1.41300",
  "surveymonkey-crm-card": "static-1.35275",
  "autolinker": "static-3.11",
  "conditional-properties-service-client": "static-1.2844",
  "google-libphonenumber": "static-1.11",
  "smart-property-lib": "static-1.307",
  "calling-error-reporting": "static-1.29947",
  "card-subscription-highlight-lib": "static-1.33365",
  "invoices-highlight-card-lib": "static-1.49217",
  "orders-highlight-card-lib": "static-1.16942",
  "project-storage": "static-1.3405",
  "quotes-highlight-card-lib": "static-1.65177",
  "crm-export-dialog": "static-1.5015",
  "customer-data-filters": "static-1.47293",
  "FormUrlGenerator": "static-2.3439",
  "testing-library": "static-1.120",
  "academy-common-lib": "static-1.9415",
  "bend-plugin-foundations-components": "static-1.2177",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "bend-plugin-foundations-theming": "static-1.1513",
  "foundations-theming-base": "static-1.2015",
  "growth-onboarding-feedback-components": "static-1.5168",
  "commerce-analytics-service-client": "static-1.2438",
  "hs-test-utils-bend-plugin": "static-1.1821",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "marketplace-ui-details": "static-1.3722",
  "navigation-components": "static-1.13681",
  "ui-shepherd-tracker": "static-1.6152",
  "property-description-translator": "static-1.2573",
  "property-management-common": "static-1.283",
  "quartz-core-utils": "static-1.2341",
  "call-summary": "static-1.31985",
  "reporting-client-types": "static-1.1833",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9185",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "conversations-async-data": "static-2.6386",
  "conversations-error-reporting": "static-1.7663",
  "conversations-http": "static-1.3518",
  "conversations-internal-schema": "static-1.11370",
  "conversations-message-history": "static-1.9814",
  "routing-ui": "static-1.15665",
  "hubs-service-types": "static-1.177",
  "salesImages": "static-1.498",
  "trials-service-types": "static-1.2806",
  "feature-store-service-types": "static-1.3398",
  "growth-monetization-service-types": "static-1.3405",
  "upgrade-management-service-types": "static-1.3389",
  "hub-http-janus": "static-1.642",
  "subscription-experience-data-types": "static-1.10351",
  "getting-started-shared-tasks-store": "static-1.11126",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11951",
  "transactions-exp-service-client-types": "static-1.11947",
  "conversations-skeleton-state": "static-1.6100",
  "integrations-lib": "static-1.10119",
  "chatspot-client-types": "static-1.8429",
  "chatspot-core": "static-1.15171",
  "ContentUtils": "static-1.62889",
  "sassPrefix": "static-1.130",
  "report-customization-components": "static-1.8488",
  "reporting-snowflake": "static-1.49972",
  "activity-history-lib": "static-1.1882",
  "assisted-buying-components": "static-1.5758",
  "bet-customer-success-shared-ui": "static-1.11914",
  "company-details-components": "static-1.4629",
  "company-details-service-types": "static-1.2643",
  "flywheel-recent-conversions-lib": "static-1.1552",
  "industries-core": "static-1.5485",
  "payment-method-components": "static-1.5264",
  "quote-checkout-common-lib": "static-1.9247",
  "quote-checkout-service-types": "static-1.2327",
  "calling-client-interface": "static-1.69832",
  "calling-cross-tab-library": "static-1.17910",
  "calling-integration-cross-tab": "static-1.17228",
  "calling-lifecycle-messages": "static-1.50970",
  "calling-lifecycle-usage-tracker": "static-1.4777",
  "calling-usage-tracker": "static-1.5209",
  "conversations-prop-types": "static-1.6138",
  "shared-worker-versioning": "static-1.9788",
  "hubspot-prosemirror-plugins": "static-1.13341",
  "redux-actions": "static-3.7",
  "share-transcript-modal": "static-1.51967",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11558",
  "domain-review-history-lib": "static-1.1961",
  "flywheel-reject-ql-lib": "static-1.1573",
  "SafeStorage": "static-1.3126",
  "ui-partner-confirmation-links-components": "static-1.21581",
  "FileManagerCore": "static-1.33653",
  "crm-activity-creator-data": "static-1.40930",
  "multi-account-crm-panel-lib": "static-1.11936",
  "sequences-crm-lib": "static-1.23085",
  "quotes-modal-lib": "static-1.95846",
  "call-timeline-event": "static-1.50595",
  "crm-events": "static-1.55214",
  "crm-meetings-components-lib": "static-1.21287",
  "svh-tickets-lib": "static-1.13453",
  "simple-logging-lib": "static-1.1752",
  "composer-data": "static-1.25339",
  "conversations-inbox-message-history": "static-1.29611",
  "conversations-infrastructure": "static-1.7647",
  "conversations-internal-pub-sub": "static-1.14723",
  "conversations-platform": "static-1.3216",
  "conversations-thread-data": "static-1.62513",
  "crm-events-viz-core": "static-1.28198",
  "hubspotter-http": "static-1.3512",
  "react-transition-group": "static-1.7",
  "ui-suspension-banners-lib": "static-1.5138",
  "zorse-crm-components-lib": "static-1.5722",
  "crm-activity-creator-interactions": "static-1.39655",
  "framework-scoring-history-panel-lib": "static-1.10061",
  "MeetingsLib": "static-2.53153",
  "hub-http-contrib": "static-1.1885",
  "task-queues": "static-1.28505",
  "ui-addon-video-player": "static-1.7481",
  "location-customization-utils-lib": "static-1.3704",
  "all-properties-panel-lib": "static-1.2452",
  "crm-events-viz-timeline": "static-1.35861",
  "customer-data-modals": "static-1.3515",
  "merge-modal-lib": "static-1.6481",
  "predictive-scores-panel": "static-1.24522",
  "property-history-panel": "static-1.19124",
  "flywheel-lead-visibility-lib": "static-1.744",
  "crm-source-interpretation-lib": "static-1.3988",
  "partner-shared-messages-lib": "static-1.12935",
  "redux-mock-store": "static-1.8",
  "automation-platform-service-types": "static-1.2099",
  "guided-selling-core": "static-1.4720",
  "sales-execution-components": "static-1.7964",
  "credit-memos-highlight-card-lib": "static-1.5213",
  "breeze-intelligence-kit": "static-1.3932",
  "policy-lib": "static-1.5508",
  "ui-coaching-tips": "static-1.22402",
  "ui-coaching-tips-shared-config": "static-1.22387",
  "analytics_js": "static-1.3267",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17907",
  "feedback-schema": "static-1.48381",
  "forms-utils-lib": "static-1.10095",
  "FormsCommonComponents": "static-1.80728",
  "integrations-tracking-lib": "static-1.4215",
  "MeetingsBase": "static-1.54745",
  "outpost": "static-1.3067",
  "partner-poi-timeline-event": "static-1.34819",
  "qualified-leads-embedded-lib": "static-1.42371",
  "quotes-crm-events-lib": "static-1.37265",
  "react-table": "static-1.15",
  "sales-clients-common": "static-1.45321",
  "sequences-client-types-lib": "static-1.5663",
  "sequences-crm-events-lib": "static-1.22888",
  "settings-ui-nav": "static-2.8794",
  "social-components-lib": "static-1.28609",
  "ui-addon-sales-email": "static-1.3928",
  "ui-tour-react": "static-1.10690",
  "urlinator": "static-1.3269",
  "outreach-assistant-email-generation": "static-1.2698",
  "quotes-client-types": "static-1.31257",
  "sales-email-signature-service-client": "static-1.2704",
  "customer-data-filters-ui-msw-helpers": "static-1.15911",
  "signup-ui-lego-core": "static-1.18053",
  "viral-links-lib": "static-1.5595",
  "media-bridge-lib": "static-1.16582",
  "video-data-lib": "static-1.29127",
  "FileManagerImages": "static-1.31304",
  "trellis-story-utils": "static-1.3269",
  "knowledge-content-types": "static-1.7664",
  "ui-addon-emoji-picker": "static-1.8654",
  "in-meeting-experience-client-types": "static-1.13495",
  "content-embed-lib": "static-1.6063",
  "crm-record-cards-service-types": "static-1.2706",
  "remote-ui": "static-1.39",
  "ui-extensions-remote-renderer": "static-1.12239",
  "universal-page-editor-lib": "static-1.1658",
  "developer-experience-shared-components": "static-1.8810",
  "immutable-less": "static-1.3276",
  "ui-extensibility-client-types": "static-1.2889",
  "markdown-it": "static-1.6",
  "hubspotter-http-shared-msw-handlers": "static-1.6963",
  "platform-navigation-bootstrap": "static-1.11129",
  "dashboard-lib": "static-1.75445",
  "share-with-third-party-component-lib": "static-1.7380",
  "data-quality-ui-library": "static-1.7725",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6672",
  "reporting-reports": "static-1.61035",
  "data-token-picker": "static-1.13989",
  "navigation-messaging": "static-1.3008",
  "attribution-lib": "static-1.37284",
  "campaigns-build-lib": "static-1.7467",
  "marketing-platform-lib": "static-1.5394",
  "growth-onboarding-reliability": "static-1.3876",
  "sales-checkout-service-client": "static-1.2450",
  "amplitude-session-replay-browser": "static-1.6",
  "stripe-embedded-components": "static-1.5110",
  "idb-keyval": "static-1.20",
  "integrations-error-boundary-lib": "static-1.7534",
  "automation-enrollment-service-types": "static-1.2647",
  "buyer-intent-lib": "static-1.372",
  "crm-cards-test-utils": "static-1.37596",
  "renewal-center-service-types": "static-1.2884",
  "submissions-lib": "static-1.41298",
  "ui-forms-components": "static-1.8090",
  "portal-details-components": "static-1.13785",
  "ui-extensions-plugin-flywheel": "static-1.9180",
  "ui-product-approvals": "static-1.23619",
  "customer-success-client-types": "static-1.14433",
  "sales-enablement-lib": "static-1.11706",
  "sales-leader-insights-components-lib": "static-1.13254",
  "guided-actions-lib": "static-1.14457",
  "framework-scoring-client-types": "static-1.11114",
  "fsm": "static-1.2425",
  "card-bet-associated-companies-lib": "static-1.71446",
  "card-bet-deal-support-requests-lib": "static-1.62187",
  "card-bet-quotes-lib": "static-1.71453",
  "card-deal-splits-lib": "static-1.38702",
  "card-flywheel-ql-summary-lib": "static-1.40333",
  "card-flywheel-recent-conversions-lib": "static-1.40334",
  "card-invoices-lib": "static-1.50886",
  "card-marketing-event-about-lib": "static-1.50668",
  "card-marketing-event-activity-lib": "static-1.50667",
  "card-past-feedback-lib": "static-1.36482",
  "card-prospecting-notes": "static-1.32797",
  "card-qualified-leads-lib": "static-1.71608",
  "card-sfdcsync-lib": "static-1.50738",
  "card-workflows-lib": "static-1.67625",
  "integrations-sync-card-ui": "static-1.21679",
  "partner-poi-crm-card": "static-1.14267",
  "recording-preview-card": "static-1.11610",
  "ui-sales-order-wizard-card": "static-1.26665",
  "predictive-scores-lib-components": "static-1.22917",
  "process-guide-chirp": "static-1.3388",
  "gapi-client-types": "static-1.3",
  "google-picker-types": "static-1.3",
  "ui-google-drive-picker": "static-1.1211",
  "crm-animations": "static-1.3738",
  "import-errors-lib": "static-1.20747",
  "deep-diff": "static-1.5",
  "academy-service-client": "static-1.2688",
  "ai-studio-lib": "static-1.5088",
  "marketplace-ui-reviews": "static-1.13781",
  "marketplace-ui-tracking": "static-1.7996",
  "cms-field-types": "static-1.3504",
  "content-icons-ui": "static-1.1871",
  "reporting-datasets-permissions-lib": "static-1.7119",
  "fintech-buying-service-clients": "static-1.2398",
  "account-and-billing-contacts-usage": "static-2.17773",
  "emoji-regex": "static-1.7",
  "signup-ui-full-screen-search": "static-1.10100",
  "billing-payments-client-types": "static-1.2769",
  "buying-experience-components": "static-1.8528",
  "checkout-service-types": "static-1.2859",
  "growth-pro-utils-lib": "static-1.8086",
  "audio-components": "static-1.4355",
  "video-components": "static-1.7479",
  "video-embed": "static-1.29968",
  "conversations-calling-message": "static-1.54373",
  "crm-events-viz-test-utils": "static-1.16819",
  "crm-pipeline-events-ui": "static-1.22457",
  "conversations-routing-lib": "static-1.5968",
  "signup-ui-url-generator": "static-2.6768",
  "usage-tracker-anonymous": "static-1.4598",
  "usage-tracker-multi": "static-1.4595",
  "automation-ui-core": "static-2.15461",
  "automation-ui-permissions": "static-1.13823",
  "workspace-components": "static-1.2833",
  "workspace-view-data": "static-1.1409",
  "settings-content-modals": "static-1.39712",
  "forms-ai-lib": "static-1.2137",
  "react-tinymce": "static-1.50274",
  "SharedLegalStrings": "static-1.1302",
  "tinymce-config": "static-2.49400",
  "meetings-client-types": "static-1.2680",
  "messaging-types-lib": "static-1.40030",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.3011",
  "platform-infra-nav-components": "static-1.6617",
  "campaign-roi-lib": "static-1.2575",
  "stripe-connect-js": "static-1.39",
  "customer-data-sidebar-test-utils": "static-1.35331",
  "form-builder-ui": "static-1.7813",
  "user-configuration-lib": "static-1.24456",
  "ui-deal-management-components-lib": "static-1.15445",
  "automation-ui-action-features": "static-1.49397",
  "codemirror": "static-5.71",
  "react-codemirror": "static-1.9330",
  "ui-signature-editor": "static-1.13532",
  "immerable": "static-1.2870",
  "social-insights-client-types": "static-1.17514",
  "automation-ui-routing": "static-1.14885",
  "automation-ui-source-apps": "static-1.12607",
  "access-control-lib": "static-1.9174",
  "EmailComponents": "static-1.48743",
  "EmailData": "static-1.47419",
  "redux-less": "static-2.8161",
  "tinymce-themes": "static-1.51370",
  "interframe": "static-3.3519",
  "tinymce-data": "static-1.35485",
  "tinymce-plugins": "static-1.52514",
  "ContentData": "static-1.62965",
  "marketing-email-service-types": "static-1.1426",
  "layout-dnd-components": "static-1.10647",
  "layout-dnd-utils": "static-1.9622",
  "app-users-service-client": "static-1.3780",
  "app-users-service-types": "static-1.3186",
  "framework-listing-lib": "static-2.22151",
  "mini-checkout-client": "static-1.24037",
  "onboarding-utils": "static-1.4076",
  "ads-client-types": "static-1.16662",
  "automation-actions-service-types": "static-1.3219",
  "automation-applications-service-types": "static-1.2468",
  "automation-ui-action-fields": "static-1.32519",
  "automation-ui-associations": "static-1.14137",
  "automation-ui-enrollment": "static-1.50926",
  "automation-ui-flow-core": "static-1.14850",
  "automation-ui-formula-editor": "static-1.11009",
  "automation-ui-i18n": "static-1.14920",
  "automation-ui-references": "static-1.14875",
  "automation-ui-types": "static-1.13525",
  "automation-ui-usage-tracking": "static-1.14929",
  "crm-properties-common-lib": "static-1.4384",
  "data-token-views": "static-1.13970",
  "fuzzy": "static-1.8",
  "messaging-editing-lib": "static-1.40294",
  "skills-lib": "static-1.24538",
  "ui-addon-automation-embed": "static-1.12197",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "ContentComponents": "static-2.65846",
  "ui-tool-access": "static-1.8775",
  "NamespacedHubStyle": "static-2.8153",
  "layout-data-lib": "static-1.7947",
  "framework-listing-lib-shared-msw-handlers": "static-1.6856",
  "touchless-buying-components": "static-1.3179",
  "merchandise-lib": "static-1.223",
  "crm-association-components-lib": "static-1.4908",
  "messaging-publishing-lib": "static-1.40246",
  "mobile-messaging-management-lib": "static-1.28819",
  "data-ops-fullstory": "static-1.4059",
  "workflows-copilot-service-types": "static-1.1480",
  "ContentEditorUI": "static-2.71332",
  "short-messages-app-service-client": "static-1.2852",
  "web-interactives-components": "static-1.11386",
  "web-interactives-data": "static-1.11387",
  "conversations-thread-view": "static-1.71244",
  "conversations-visibility-tools": "static-1.4470",
  "simple-menus-core": "static-1.13465",
  "simple-menus-lib": "static-1.14982",
  "ui-memberships-settings-lib": "static-1.28096",
  "videoconference-integration-components": "static-1.4851",
  "checkout-sdk": "static-3.20880",
  "upgrade-catalog-service-types": "static-1.2577",
  "messaging-management-lib": "static-1.11806",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3781",
  "copilot-plugins": "static-1.5940",
  "cta-picker": "static-1.31093",
  "editor-components": "static-1.11731",
  "editor-iframe-lib": "static-1.7029",
  "error-messaging-js": "static-1.4012",
  "pictos": "static-7.159",
  "redux-request-state": "static-1.9299",
  "smart-content-core": "static-1.37044",
  "smart-content-lib": "static-1.37697",
  "social-composer-lib": "static-1.53079",
  "structured-content-lib": "static-1.19941",
  "theme-previewer-lib": "static-1.47686",
  "tinymce-copilot": "static-1.11468",
  "ui-active-theme-content-creator-lib": "static-1.31619",
  "xray-recommendation-lib": "static-1.5860",
  "calling-integration-help-desk": "static-1.19034",
  "seamless-immutable": "static-7.6",
  "hub-http-rxjs": "static-1.609",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4754",
  "ui-brand-identity-lib": "static-1.8302",
  "codemirror-dlb": "static-1.52887",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-index-ui": "/crm-index-ui/static-2.46863",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3293",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29813",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38404",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.6057",
  "client-types": "/client-types/static-1.372",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5851",
  "commerce-products-lib": "/commerce-products-lib/static-1.4591",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14475",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6297",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3322",
  "contextual-settings-lib": "/contextual-settings-lib/static-1.1780",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5858",
  "crm_data": "/crm_data/static-4.86423",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.14504",
  "crm-common-dlb": "/crm-common-dlb/static-1.4037",
  "crm-component-utils": "/crm-component-utils/static-1.34250",
  "crm-configuration-iframe-lib": "/crm-configuration-iframe-lib/static-1.297",
  "crm-configuration-onboarding-lib": "/crm-configuration-onboarding-lib/static-1.5275",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5103",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.2627",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22501",
  "crm-legacy-links": "/crm-legacy-links/static-1.71309",
  "crm-message-bus": "/crm-message-bus/static-1.36382",
  "crm-object-board-core": "/crm-object-board-core/static-1.12439",
  "crm-object-gantt": "/crm-object-gantt/static-1.2480",
  "crm-object-map": "/crm-object-map/static-1.1768",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6131",
  "crm-object-search-query-utilities-test-utils": "/crm-object-search-query-utilities-test-utils/static-1.5792",
  "crm-pipeline-board-settings-lib": "/crm-pipeline-board-settings-lib/static-1.25502",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3055",
  "customer-data-bulk-actions": "/customer-data-bulk-actions/static-1.29745",
  "customer-data-objects": "/customer-data-objects/static-1.6330",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11603",
  "customer-data-properties": "/customer-data-properties/static-1.45420",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40653",
  "customer-data-views-management": "/customer-data-views-management/static-1.22009",
  "data-fetching-client": "/data-fetching-client/static-1.8338",
  "data-privacy-hub-settings-service-types": "/data-privacy-hub-settings-service-types/static-1.2904",
  "demographics-client": "/demographics-client/static-1.4129",
  "dispatcher": "/dispatcher/static-1.111",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9955",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.300",
  "external-options-client-types": "/external-options-client-types/static-1.3008",
  "feedback-loader": "/feedback-loader/static-1.26420",
  "foundations-components": "/foundations-components/static-1.5909",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3394",
  "foundations-theming": "/foundations-theming/static-1.3030",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.747",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5488",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5583",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7051",
  "framework-data-table": "/framework-data-table/static-2.8470",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.2447",
  "growth-payments-core": "/growth-payments-core/static-1.20846",
  "head-dlb": "/head-dlb/static-1.3911",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-promise-utils": "/hs-promise-utils/static-1.4245",
  "hs-test-utils": "/hs-test-utils/static-1.6710",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3546",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10213",
  "I18n": "/I18n/static-7.1383",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2708",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2851",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3137",
  "jasmine-immutable": "/jasmine-immutable/static-1.1682",
  "jasmine-runner": "/jasmine-runner/static-1.5125",
  "laboratory-lib": "/laboratory-lib/static-3.5970",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4962",
  "marketplace-embed": "/marketplace-embed/static-1.16135",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11228",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41701",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.95",
  "onboarding-scopes": "/onboarding-scopes/static-1.5271",
  "onboarding-tours": "/onboarding-tours/static-1.14113",
  "payments-zero-states-lib": "/payments-zero-states-lib/static-1.14351",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2796",
  "PortalIdParser": "/PortalIdParser/static-2.278",
  "products-iframe-lib": "/products-iframe-lib/static-1.2714",
  "products-ui-components": "/products-ui-components/static-1.35111",
  "property-management-iframe": "/property-management-iframe/static-1.7997",
  "quartz": "/quartz/static-1.5474",
  "quick-fetch": "/quick-fetch/static-1.2908",
  "raven": "/raven/static-3.4646",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.52",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15302",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4249",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.26261",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6692",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7111",
  "reporting-data": "/reporting-data/static-1.61351",
  "reporting-dlb": "/reporting-dlb/static-1.54269",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.3286",
  "reporting-visualizations": "/reporting-visualizations/static-1.53428",
  "sales-views-client-types": "/sales-views-client-types/static-1.3049",
  "self-service-api": "/self-service-api/static-1.8918",
  "settings-ui-lib": "/settings-ui-lib/static-1.11273",
  "signup-constants": "/signup-constants/static-1.16043",
  "styled-components": "/styled-components/static-2.64",
  "superstore": "/superstore/static-1.3488",
  "svh-onboarding-config-shared-lib": "/svh-onboarding-config-shared-lib/static-1.2242",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10774",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1198",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6707",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15921",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4352",
  "UIComponents": "/UIComponents/static-3.7161",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.3402",
  "usage-tracker-core": "/usage-tracker-core/static-1.6031",
  "user-context": "/user-context/static-1.3887",
  "webpack-env": "/webpack-env/static-1.54",
  "wootric-nps": "/wootric-nps/static-1.5662",
  "account-and-billing-components": "/account-and-billing-components/static-1.16315",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15065",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.31155",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4754",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5091",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3503",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38628",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.40337",
  "call-widget-addon": "/call-widget-addon/static-2.27400",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.25454",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.13154",
  "calling-internal-common": "/calling-internal-common/static-1.29941",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.58674",
  "calling-ui-library": "/calling-ui-library/static-1.64593",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.71467",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.71468",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.71467",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49769",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32522",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.63504",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67714",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41762",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67703",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.35495",
  "card-lists-lib": "/card-lists-lib/static-1.65825",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.32023",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.31367",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57992",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.70051",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.51541",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78696",
  "card-properties-lib": "/card-properties-lib/static-1.38490",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32797",
  "card-target-account-lib": "/card-target-account-lib/static-1.67452",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.68251",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.15165",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.52032",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14452",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25767",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30942",
  "composer-plugins": "/composer-plugins/static-1.66498",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.29177",
  "copilot-toolkit": "/copilot-toolkit/static-1.5967",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5860",
  "crm_components": "/crm_components/static-3.86423",
  "crm_schema": "/crm_schema/static-3.86460",
  "crm_ui": "/crm_ui/static-5.86381",
  "crm_universal": "/crm_universal/static-1.20465",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.40383",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30852",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.46434",
  "crm-associations-table": "/crm-associations-table/static-1.36099",
  "crm-cards": "/crm-cards/static-1.39046",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37749",
  "crm-command-handler": "/crm-command-handler/static-1.30450",
  "crm-display-components": "/crm-display-components/static-1.20000",
  "crm-events-components": "/crm-events-components/static-1.55207",
  "crm-events-data": "/crm-events-data/static-1.55220",
  "crm-fe-perf": "/crm-fe-perf/static-1.21719",
  "crm-index-ui-toolbar": "/crm-index-ui-toolbar/static-1.1938",
  "crm-index-view-table-edit-columns-modal": "/crm-index-view-table-edit-columns-modal/static-1.15669",
  "crm-index-visualization-toolbar": "/crm-index-visualization-toolbar/static-1.2363",
  "crm-index-visualization-toolbar-test-utils": "/crm-index-visualization-toolbar-test-utils/static-1.1734",
  "crm-links": "/crm-links/static-1.4820",
  "crm-object-board": "/crm-object-board/static-1.22360",
  "crm-object-board-card": "/crm-object-board-card/static-1.12435",
  "crm-object-preview": "/crm-object-preview/static-1.21057",
  "crm-object-table": "/crm-object-table/static-1.17217",
  "crm-timeline": "/crm-timeline/static-1.83546",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32359",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.472",
  "customer-data-board": "/customer-data-board/static-1.19450",
  "customer-data-board-card": "/customer-data-board-card/static-1.19411",
  "customer-data-bulk-actions-container": "/customer-data-bulk-actions-container/static-1.15456",
  "customer-data-communicator": "/customer-data-communicator/static-1.39868",
  "customer-data-email": "/customer-data-email/static-1.15671",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33478",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6646",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11700",
  "customer-data-rte": "/customer-data-rte/static-1.28748",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8445",
  "deal-registration-ui": "/deal-registration-ui/static-1.29832",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.39316",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.39222",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.20019",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.19156",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19782",
  "email-confirm-ui": "/email-confirm-ui/static-2.4344",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20358",
  "ExportDialog": "/ExportDialog/static-6.9110",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.529",
  "file-manager-components": "/file-manager-components/static-1.18153",
  "FileManagerLib": "/FileManagerLib/static-1.33794",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5998",
  "foundations-assets": "/foundations-assets/static-1.3635",
  "framework-app-settings-features-lib": "/framework-app-settings-features-lib/static-1.3764",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6591",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12008",
  "graphql": "/graphql/static-1.58",
  "growth-data-modal": "/growth-data-modal/static-1.3930",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4372",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4591",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3902",
  "HeadJS": "/HeadJS/static-2.570",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13349",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "HubStyle": "/HubStyle/static-2.10522",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16795",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9371",
  "integration-settings-components": "/integration-settings-components/static-1.10339",
  "integrations-directory-panel-lib": "/integrations-directory-panel-lib/static-1.7725",
  "invoices-card-lib": "/invoices-card-lib/static-1.51361",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51290",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.49232",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33651",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7861",
  "marketing-contacts-ui": "/marketing-contacts-ui/static-1.6353",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31602",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12358",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13822",
  "metrics-js": "/metrics-js/static-1.8459",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.341",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6551",
  "nav-meta": "/nav-meta/static-1.25318",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5881",
  "onboarding-data-sync-lib-shared-msw-handlers": "/onboarding-data-sync-lib-shared-msw-handlers/static-1.15",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3216",
  "orders-card-lib": "/orders-card-lib/static-1.16659",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.22440",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.42139",
  "playbooks-modal": "/playbooks-modal/static-1.75165",
  "playlists-lib": "/playlists-lib/static-1.6634",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12876",
  "property-translator": "/property-translator/static-1.4112",
  "quartz-core": "/quartz-core/static-1.4693",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73889",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.8958",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.65",
  "recent-activities-card": "/recent-activities-card/static-1.53071",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reference-resolvers": "/reference-resolvers/static-1.6869",
  "reporting-action-components": "/reporting-action-components/static-1.35921",
  "reporting-crm-object-table": "/reporting-crm-object-table/static-1.2519",
  "reporting-enablement": "/reporting-enablement/static-1.16727",
  "reporting-ui-components": "/reporting-ui-components/static-2.58629",
  "reselect": "/reselect/static-2.16",
  "rich-text-lib": "/rich-text-lib/static-1.17313",
  "rpc-client-utils": "/rpc-client-utils/static-1.3434",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6996",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7670",
  "sanitize-text": "/sanitize-text/static-1.6896",
  "sequences-lib": "/sequences-lib/static-1.5807",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "subscriptions-components": "/subscriptions-components/static-1.41060",
  "svh-conversations-settings-lib": "/svh-conversations-settings-lib/static-1.2242",
  "tasks-lib": "/tasks-lib/static-1.32433",
  "timezone-utils": "/timezone-utils/static-2.3965",
  "transcript-sidebar": "/transcript-sidebar/static-1.62322",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4460",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8148",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9737",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9642",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7606",
  "ui-addon-opt": "/ui-addon-opt/static-4.7366",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8327",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11107",
  "ui-addon-teams": "/ui-addon-teams/static-1.19660",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8954",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7591",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8966",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8771",
  "ui-universal-auth": "/ui-universal-auth/static-1.7510",
  "usage-tracker": "/usage-tracker/static-1.6181",
  "usage-tracker-container": "/usage-tracker-container/static-1.6171",
  "atom": "/atom/static-1.3938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sanitize": "/sanitize/static-1.3102",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
  "raven-hubspot": "/raven-hubspot/static-1.4953",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2374",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1751",
  "quartz-webpack": "/quartz-webpack/static-1.1698",
  "ably": "/ably/static-1.18",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30038",
  "avatar-components": "/avatar-components/static-1.1137",
  "calling-global-api": "/calling-global-api/static-1.57292",
  "campaigns-lib": "/campaigns-lib/static-1.21922",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.31503",
  "customer-data-tracking": "/customer-data-tracking/static-1.5516",
  "payment-link-components": "/payment-link-components/static-1.18264",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9198",
  "persist-promise": "/persist-promise/static-1.2463",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1285",
  "zustand": "/zustand/static-1.51",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7350",
  "hs-story-utils": "/hs-story-utils/static-1.8112",
  "msw": "/msw/static-1.39",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17356",
  "StyleGuideUI": "/StyleGuideUI/static-3.456",
  "ui-images": "/ui-images/static-2.812",
  "cv-backend-services": "/cv-backend-services/static-1.1120",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1826",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3813",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "react-dnd-compat": "/react-dnd-compat/static-1.3374",
  "magpie-lib": "/magpie-lib/static-1.4389",
  "magpie-types": "/magpie-types/static-1.3849",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.13002",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4303",
  "ai-catchup-cards-lib": "/ai-catchup-cards-lib/static-1.2389",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4968",
  "buyer-intent-card": "/buyer-intent-card/static-1.16082",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.30047",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13716",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.21073",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.2145",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.11174",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.802",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.11174",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2780",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.4212",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6754",
  "card-lead-insights": "/card-lead-insights/static-1.9485",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24930",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.1512",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2866",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.15029",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25945",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.20310",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.2373",
  "card-target-account-signals": "/card-target-account-signals/static-1.922",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9619",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11466",
  "commerce-billing-engine-lib": "/commerce-billing-engine-lib/static-1.1316",
  "crm-actions": "/crm-actions/static-1.4779",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.34229",
  "crm-attribution-report": "/crm-attribution-report/static-1.553",
  "crm-clv-report": "/crm-clv-report/static-1.2887",
  "crm-data-highlights": "/crm-data-highlights/static-1.36637",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35853",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27406",
  "crm-extension": "/crm-extension/static-1.35957",
  "crm-csat": "/crm-csat/static-1.159",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18903",
  "crm-properties-list": "/crm-properties-list/static-1.33275",
  "crm-property-history": "/crm-property-history/static-1.11335",
  "crm-quick-actions": "/crm-quick-actions/static-1.12785",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.13213",
  "crm-report": "/crm-report/static-1.36844",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13431",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31808",
  "crm-statistics": "/crm-statistics/static-1.25853",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.414",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.4524",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12800",
  "deal-summary-components": "/deal-summary-components/static-1.15638",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.22405",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1755",
  "guided-actions-card": "/guided-actions-card/static-1.9204",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.6416",
  "health-score-card-lib": "/health-score-card-lib/static-1.16083",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9914",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.8087",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25645",
  "lead-scores-card": "/lead-scores-card/static-1.12357",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.29597",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.23163",
  "playbooks-card": "/playbooks-card/static-1.37875",
  "predictive-scores-card": "/predictive-scores-card/static-1.25519",
  "process-guide-cards": "/process-guide-cards/static-1.3556",
  "products-cards-lib": "/products-cards-lib/static-1.4184",
  "purchase-history-lib": "/purchase-history-lib/static-1.15345",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.1640",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.1642",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6295",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5798",
  "crm-configuration-common-lib": "/crm-configuration-common-lib/static-1.6835",
  "crm-import-wizard-lib": "/crm-import-wizard-lib/static-1.36944",
  "react-flip-move": "/react-flip-move/static-1.46",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2982",
  "user-context-client": "/user-context-client/static-1.3468",
  "ts-schema": "/ts-schema/static-1.3059",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2980",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6965",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2729",
  "customer-data-associations": "/customer-data-associations/static-1.5921",
  "react-virtualized-auto-sizer": "/react-virtualized-auto-sizer/static-1.24",
  "react-window": "/react-window/static-1.13",
  "task-forms-lib": "/task-forms-lib/static-1.35729",
  "universal-associations-select": "/universal-associations-select/static-1.9510",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.151",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "csstype": "/csstype/static-1.38",
  "jasmine": "/jasmine/static-4.3059",
  "usage-tracker-public": "/usage-tracker-public/static-1.5992",
  "content-assistance-lib": "/content-assistance-lib/static-1.6204",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.21038",
  "customer-data-content": "/customer-data-content/static-1.24371",
  "draft-content-plugins": "/draft-content-plugins/static-1.24097",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.9427",
  "FireAlarmUi": "/FireAlarmUi/static-1.3561",
  "flux-actions": "/flux-actions/static-1.268",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6354",
  "pipeline-governance-client-types": "/pipeline-governance-client-types/static-1.3112",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6747",
  "react-virtualized": "/react-virtualized/static-2.73",
  "subscriptions-client": "/subscriptions-client/static-1.41300",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.35275",
  "autolinker": "/autolinker/static-3.11",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2844",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "smart-property-lib": "/smart-property-lib/static-1.307",
  "calling-error-reporting": "/calling-error-reporting/static-1.29947",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.33365",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.49217",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16942",
  "project-storage": "/project-storage/static-1.3405",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.65177",
  "crm-export-dialog": "/crm-export-dialog/static-1.5015",
  "customer-data-filters": "/customer-data-filters/static-1.47293",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3439",
  "testing-library": "/testing-library/static-1.120",
  "academy-common-lib": "/academy-common-lib/static-1.9415",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2177",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1513",
  "foundations-theming-base": "/foundations-theming-base/static-1.2015",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5168",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2438",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1821",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3722",
  "navigation-components": "/navigation-components/static-1.13681",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6152",
  "property-description-translator": "/property-description-translator/static-1.2573",
  "property-management-common": "/property-management-common/static-1.283",
  "quartz-core-utils": "/quartz-core-utils/static-1.2341",
  "call-summary": "/call-summary/static-1.31985",
  "reporting-client-types": "/reporting-client-types/static-1.1833",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9185",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "conversations-async-data": "/conversations-async-data/static-2.6386",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7663",
  "conversations-http": "/conversations-http/static-1.3518",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11370",
  "conversations-message-history": "/conversations-message-history/static-1.9814",
  "routing-ui": "/routing-ui/static-1.15665",
  "hubs-service-types": "/hubs-service-types/static-1.177",
  "salesImages": "/salesImages/static-1.498",
  "trials-service-types": "/trials-service-types/static-1.2806",
  "feature-store-service-types": "/feature-store-service-types/static-1.3398",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3405",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3389",
  "hub-http-janus": "/hub-http-janus/static-1.642",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10351",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11126",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11951",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11947",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6100",
  "integrations-lib": "/integrations-lib/static-1.10119",
  "chatspot-client-types": "/chatspot-client-types/static-1.8429",
  "chatspot-core": "/chatspot-core/static-1.15171",
  "ContentUtils": "/ContentUtils/static-1.62889",
  "sassPrefix": "/sassPrefix/static-1.130",
  "report-customization-components": "/report-customization-components/static-1.8488",
  "reporting-snowflake": "/reporting-snowflake/static-1.49972",
  "activity-history-lib": "/activity-history-lib/static-1.1882",
  "assisted-buying-components": "/assisted-buying-components/static-1.5758",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11914",
  "company-details-components": "/company-details-components/static-1.4629",
  "company-details-service-types": "/company-details-service-types/static-1.2643",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.1552",
  "industries-core": "/industries-core/static-1.5485",
  "payment-method-components": "/payment-method-components/static-1.5264",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.9247",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2327",
  "calling-client-interface": "/calling-client-interface/static-1.69832",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17910",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.17228",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50970",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4777",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5209",
  "conversations-prop-types": "/conversations-prop-types/static-1.6138",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9788",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13341",
  "redux-actions": "/redux-actions/static-3.7",
  "share-transcript-modal": "/share-transcript-modal/static-1.51967",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11558",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1961",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.1573",
  "SafeStorage": "/SafeStorage/static-1.3126",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21581",
  "FileManagerCore": "/FileManagerCore/static-1.33653",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40930",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11936",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.23085",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95846",
  "call-timeline-event": "/call-timeline-event/static-1.50595",
  "crm-events": "/crm-events/static-1.55214",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.21287",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.13453",
  "simple-logging-lib": "/simple-logging-lib/static-1.1752",
  "composer-data": "/composer-data/static-1.25339",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29611",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7647",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14723",
  "conversations-platform": "/conversations-platform/static-1.3216",
  "conversations-thread-data": "/conversations-thread-data/static-1.62513",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.28198",
  "hubspotter-http": "/hubspotter-http/static-1.3512",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5138",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5722",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39655",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.10061",
  "MeetingsLib": "/MeetingsLib/static-2.53153",
  "hub-http-contrib": "/hub-http-contrib/static-1.1885",
  "task-queues": "/task-queues/static-1.28505",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7481",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3704",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.2452",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35861",
  "customer-data-modals": "/customer-data-modals/static-1.3515",
  "merge-modal-lib": "/merge-modal-lib/static-1.6481",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.24522",
  "property-history-panel": "/property-history-panel/static-1.19124",
  "flywheel-lead-visibility-lib": "/flywheel-lead-visibility-lib/static-1.744",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3988",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12935",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2099",
  "guided-selling-core": "/guided-selling-core/static-1.4720",
  "sales-execution-components": "/sales-execution-components/static-1.7964",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.5213",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3932",
  "policy-lib": "/policy-lib/static-1.5508",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22402",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.22387",
  "analytics_js": "/analytics_js/static-1.3267",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17907",
  "feedback-schema": "/feedback-schema/static-1.48381",
  "forms-utils-lib": "/forms-utils-lib/static-1.10095",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80728",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4215",
  "MeetingsBase": "/MeetingsBase/static-1.54745",
  "outpost": "/outpost/static-1.3067",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34819",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.42371",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.37265",
  "react-table": "/react-table/static-1.15",
  "sales-clients-common": "/sales-clients-common/static-1.45321",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5663",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22888",
  "settings-ui-nav": "/settings-ui-nav/static-2.8794",
  "social-components-lib": "/social-components-lib/static-1.28609",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3928",
  "ui-tour-react": "/ui-tour-react/static-1.10690",
  "urlinator": "/urlinator/static-1.3269",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2698",
  "quotes-client-types": "/quotes-client-types/static-1.31257",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2704",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15911",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18053",
  "viral-links-lib": "/viral-links-lib/static-1.5595",
  "media-bridge-lib": "/media-bridge-lib/static-1.16582",
  "video-data-lib": "/video-data-lib/static-1.29127",
  "FileManagerImages": "/FileManagerImages/static-1.31304",
  "trellis-story-utils": "/trellis-story-utils/static-1.3269",
  "knowledge-content-types": "/knowledge-content-types/static-1.7664",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8654",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13495",
  "content-embed-lib": "/content-embed-lib/static-1.6063",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2706",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.12239",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1658",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8810",
  "immutable-less": "/immutable-less/static-1.3276",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2889",
  "markdown-it": "/markdown-it/static-1.6",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6963",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11129",
  "dashboard-lib": "/dashboard-lib/static-1.75445",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7380",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7725",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6672",
  "reporting-reports": "/reporting-reports/static-1.61035",
  "data-token-picker": "/data-token-picker/static-1.13989",
  "navigation-messaging": "/navigation-messaging/static-1.3008",
  "attribution-lib": "/attribution-lib/static-1.37284",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.7467",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5394",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3876",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2450",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5110",
  "idb-keyval": "/idb-keyval/static-1.20",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7534",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2647",
  "buyer-intent-lib": "/buyer-intent-lib/static-1.372",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37596",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2884",
  "submissions-lib": "/submissions-lib/static-1.41298",
  "ui-forms-components": "/ui-forms-components/static-1.8090",
  "portal-details-components": "/portal-details-components/static-1.13785",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.9180",
  "ui-product-approvals": "/ui-product-approvals/static-1.23619",
  "customer-success-client-types": "/customer-success-client-types/static-1.14433",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.11706",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.13254",
  "guided-actions-lib": "/guided-actions-lib/static-1.14457",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.11114",
  "fsm": "/fsm/static-1.2425",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.71446",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.62187",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.71453",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38702",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.40333",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.40334",
  "card-invoices-lib": "/card-invoices-lib/static-1.50886",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50668",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50667",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.36482",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32797",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71608",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50738",
  "card-workflows-lib": "/card-workflows-lib/static-1.67625",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21679",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.14267",
  "recording-preview-card": "/recording-preview-card/static-1.11610",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26665",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22917",
  "process-guide-chirp": "/process-guide-chirp/static-1.3388",
  "gapi-client-types": "/gapi-client-types/static-1.3",
  "google-picker-types": "/google-picker-types/static-1.3",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.1211",
  "crm-animations": "/crm-animations/static-1.3738",
  "import-errors-lib": "/import-errors-lib/static-1.20747",
  "deep-diff": "/deep-diff/static-1.5",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "ai-studio-lib": "/ai-studio-lib/static-1.5088",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13781",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7996",
  "cms-field-types": "/cms-field-types/static-1.3504",
  "content-icons-ui": "/content-icons-ui/static-1.1871",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.7119",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2398",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17773",
  "emoji-regex": "/emoji-regex/static-1.7",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10100",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2769",
  "buying-experience-components": "/buying-experience-components/static-1.8528",
  "checkout-service-types": "/checkout-service-types/static-1.2859",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.8086",
  "audio-components": "/audio-components/static-1.4355",
  "video-components": "/video-components/static-1.7479",
  "video-embed": "/video-embed/static-1.29968",
  "conversations-calling-message": "/conversations-calling-message/static-1.54373",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16819",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.22457",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5968",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6768",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4598",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4595",
  "automation-ui-core": "/automation-ui-core/static-2.15461",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13823",
  "workspace-components": "/workspace-components/static-1.2833",
  "workspace-view-data": "/workspace-view-data/static-1.1409",
  "settings-content-modals": "/settings-content-modals/static-1.39712",
  "forms-ai-lib": "/forms-ai-lib/static-1.2137",
  "react-tinymce": "/react-tinymce/static-1.50274",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1302",
  "tinymce-config": "/tinymce-config/static-2.49400",
  "meetings-client-types": "/meetings-client-types/static-1.2680",
  "messaging-types-lib": "/messaging-types-lib/static-1.40030",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.3011",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6617",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2575",
  "stripe-connect-js": "/stripe-connect-js/static-1.39",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.35331",
  "form-builder-ui": "/form-builder-ui/static-1.7813",
  "user-configuration-lib": "/user-configuration-lib/static-1.24456",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15445",
  "automation-ui-action-features": "/automation-ui-action-features/static-1.49397",
  "codemirror": "/codemirror/static-5.71",
  "react-codemirror": "/react-codemirror/static-1.9330",
  "ui-signature-editor": "/ui-signature-editor/static-1.13532",
  "immerable": "/immerable/static-1.2870",
  "social-insights-client-types": "/social-insights-client-types/static-1.17514",
  "automation-ui-routing": "/automation-ui-routing/static-1.14885",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12607",
  "access-control-lib": "/access-control-lib/static-1.9174",
  "EmailComponents": "/EmailComponents/static-1.48743",
  "EmailData": "/EmailData/static-1.47419",
  "redux-less": "/redux-less/static-2.8161",
  "tinymce-themes": "/tinymce-themes/static-1.51370",
  "interframe": "/interframe/static-3.3519",
  "tinymce-data": "/tinymce-data/static-1.35485",
  "tinymce-plugins": "/tinymce-plugins/static-1.52514",
  "ContentData": "/ContentData/static-1.62965",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1426",
  "layout-dnd-components": "/layout-dnd-components/static-1.10647",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9622",
  "app-users-service-client": "/app-users-service-client/static-1.3780",
  "app-users-service-types": "/app-users-service-types/static-1.3186",
  "framework-listing-lib": "/framework-listing-lib/static-2.22151",
  "mini-checkout-client": "/mini-checkout-client/static-1.24037",
  "onboarding-utils": "/onboarding-utils/static-1.4076",
  "ads-client-types": "/ads-client-types/static-1.16662",
  "automation-actions-service-types": "/automation-actions-service-types/static-1.3219",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2468",
  "automation-ui-action-fields": "/automation-ui-action-fields/static-1.32519",
  "automation-ui-associations": "/automation-ui-associations/static-1.14137",
  "automation-ui-enrollment": "/automation-ui-enrollment/static-1.50926",
  "automation-ui-flow-core": "/automation-ui-flow-core/static-1.14850",
  "automation-ui-formula-editor": "/automation-ui-formula-editor/static-1.11009",
  "automation-ui-i18n": "/automation-ui-i18n/static-1.14920",
  "automation-ui-references": "/automation-ui-references/static-1.14875",
  "automation-ui-types": "/automation-ui-types/static-1.13525",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.14929",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.4384",
  "data-token-views": "/data-token-views/static-1.13970",
  "fuzzy": "/fuzzy/static-1.8",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.40294",
  "skills-lib": "/skills-lib/static-1.24538",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12197",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentComponents": "/ContentComponents/static-2.65846",
  "ui-tool-access": "/ui-tool-access/static-1.8775",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8153",
  "layout-data-lib": "/layout-data-lib/static-1.7947",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6856",
  "touchless-buying-components": "/touchless-buying-components/static-1.3179",
  "merchandise-lib": "/merchandise-lib/static-1.223",
  "crm-association-components-lib": "/crm-association-components-lib/static-1.4908",
  "messaging-publishing-lib": "/messaging-publishing-lib/static-1.40246",
  "mobile-messaging-management-lib": "/mobile-messaging-management-lib/static-1.28819",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.4059",
  "workflows-copilot-service-types": "/workflows-copilot-service-types/static-1.1480",
  "ContentEditorUI": "/ContentEditorUI/static-2.71332",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2852",
  "web-interactives-components": "/web-interactives-components/static-1.11386",
  "web-interactives-data": "/web-interactives-data/static-1.11387",
  "conversations-thread-view": "/conversations-thread-view/static-1.71244",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4470",
  "simple-menus-core": "/simple-menus-core/static-1.13465",
  "simple-menus-lib": "/simple-menus-lib/static-1.14982",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.28096",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4851",
  "checkout-sdk": "/checkout-sdk/static-3.20880",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2577",
  "messaging-management-lib": "/messaging-management-lib/static-1.11806",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3781",
  "copilot-plugins": "/copilot-plugins/static-1.5940",
  "cta-picker": "/cta-picker/static-1.31093",
  "editor-components": "/editor-components/static-1.11731",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.7029",
  "error-messaging-js": "/error-messaging-js/static-1.4012",
  "pictos": "/pictos/static-7.159",
  "redux-request-state": "/redux-request-state/static-1.9299",
  "smart-content-core": "/smart-content-core/static-1.37044",
  "smart-content-lib": "/smart-content-lib/static-1.37697",
  "social-composer-lib": "/social-composer-lib/static-1.53079",
  "structured-content-lib": "/structured-content-lib/static-1.19941",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47686",
  "tinymce-copilot": "/tinymce-copilot/static-1.11468",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31619",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5860",
  "calling-integration-help-desk": "/calling-integration-help-desk/static-1.19034",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.609",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4754",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.8302",
  "codemirror-dlb": "/codemirror-dlb/static-1.52887",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
